import { accessStatusLabels, formatLastLogin, type AccessStatus } from "@/lib/last-login";

export function AccountMetadata({ status, lastLoginAt, timeZone, label = "Account Status" }: {
  status: AccessStatus; lastLoginAt: string | null; timeZone?: string; label?: string;
}) {
  const hasAccount = status === "ACTIVE" || status === "DISABLED";
  return <dl className="mt-2 grid min-w-0 gap-1 text-sm text-slate-400">
    <div><dt className="inline">{label}: </dt><dd className="inline text-white">{accessStatusLabels[status]}</dd></div>
    {hasAccount && <div className="break-words"><dt className="inline">Last Login: </dt><dd className="inline">{formatLastLogin(lastLoginAt, timeZone)}</dd></div>}
  </dl>;
}
